import { __ } from "@wordpress/i18n";
import { ReactComponent as ExportIcon } from "../../assets/export.svg";
import { ReactComponent as UploadIcon } from "../../assets/upload.svg";

import { useRef, useState } from "react";
import { exportStringToFile } from "../../Helpers/Utils";
import { ajaxCall } from "../../Helpers/AjaxHelper";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../Helpers/ReduxHelper";

const ExportSection = () => {
  const [feedList] = useState(window.sby_settings.feeds);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const uploadRef = useRef();
  const dispatch = useDispatch();

  const onExport = () => {
    if (selectedFeed !== "-1" && selectedFeed !== null) {
      exportStringToFile(
        JSON.stringify({
          feedName: feedList[selectedFeed].feed_name,
          ...JSON.parse(feedList[selectedFeed].settings),
        }),
        `sby-feed-${feedList[selectedFeed].id}.json`
      );
    }
  };

  const onImport = () => {
    if (uploadRef.current) {
      uploadRef.current.click();
    }
  };

  return (
    <>
      <div className="sb-tab-box sb-custom-css-box sb-reset-box-style clearfix">
        <div className="tab-label">
          <h3>{__("Import Feed Settings", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field">
          <div className="sb-form-field">
            <div className="d-flex ">
              <label htmlFor="sby_json_upload">
                <input
                  type="file"
                  id="sby_json_upload"
                  ref={uploadRef}
                  style={{
                    display: "none",
                  }}
                  onChange={(evt) => {
                    const feedFile = evt.target.files[0];
                    if (feedFile) {
                      ajaxCall("sby_do_feed_import", {
                        feedFile,
                      })
                        .then((res) => res.json())
                        .then(({ data }) =>
                          dispatch(
                            setNotificationAction(
                              data.message,
                              data.success ? "success" : "error"
                            )
                          )
                        )
                        .finally(() => {
                          evt.target.value = null;
                        });
                    }
                  }}
                  accept="application/json"
                />
                <button
                  type="button"
                  className="sby-btn sb-btn-lg sb-btn-grey export-btn"
                  onClick={onImport}
                >
                  <span className="icon">
                    <UploadIcon />
                  </span>
                  {__("Import", "feeds-for-youtube")}
                </button>
              </label>
            </div>
            <span className="help-text">
              {__(
                "You will need a JSON file previously exported from the Feeds for YouTube Plugin",
                "feeds-for-youtube"
              )}
            </span>
          </div>
        </div>
      </div>
      <div className="sb-tab-box sb-export-box clearfix">
        <div className="tab-label">
          <h3>{__("Export Feed Settings", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field">
          <div className="sb-form-field">
            <div className="d-flex mb-15">
              <select
                defaultValue="none"
                name=""
                id="sby-feeds-list"
                className="sby-select"
                onChange={(evt) => {
                  setSelectedFeed(evt.target.value);
                }}
              >
                <option value="-1">
                  {__("Select Feed", "feeds-for-youtube")}
                </option>
                {feedList.map((feed, index) => {
                  return <option value={index}>{feed.feed_name}</option>;
                })}
              </select>
              <button
                disabled={selectedFeed === "-1" || selectedFeed === null}
                type="button"
                className="sby-btn sb-btn-lg sb-btn-grey export-btn"
                onClick={onExport}
              >
                <span className="icon">
                  <ExportIcon />
                </span>
                {__("Export", "feeds-for-youtube")}
              </button>
            </div>
            <span className="help-text">
              {__(
                "Export settings for one or more of your feeds",
                "feeds-for-youtube"
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExportSection;
